/**
 * Подання «Мої задачі» (tasks-today.md, розд. 4; TSK-20): п'ять подань поведінки `activities_task`
 * на сутності задач. Окремого екрана немає: це загальний список `/l/<сутність>.<подання>`, але
 * подання поведінки мають умову з якорем часткового індексу (E8a-4), а загальний список її не шле.
 * Тому `ListPage` віддає їх лінивому екрану «Мої задачі» (`features/tasks/my/`), а `loader` маршруту
 * не тягне для них першої порції загального списку.
 *
 * Файл першого екрана: лише ключі й перевірка, без React і мережі.
 */
import type { AppMeta, MetaEntity, MetaView } from '@clientline/contracts';
import { TASK_BEHAVIOR } from './outcome/types.ts';

/** Ключі подань у порядку перемикача (tasks-today.md, розд. 4; `TASK_VIEWS` модуля). */
export const TASK_VIEW_KEYS = [
  'today',
  'overdue',
  'upcoming',
  'no_due',
  'done_30d',
  'delegated',
] as const;
export type TaskViewKey = (typeof TASK_VIEW_KEYS)[number];

const KEYS: ReadonlySet<string> = new Set(TASK_VIEW_KEYS);

/**
 * Ключ подання задач або `null`: подання сутності з поведінкою `activities_task` і ключем з
 * переліку. Подання ядра (`mine`, `all`) і компанії на тій самій сутності лишаються загальним
 * списком.
 */
export function taskViewKey(view: MetaView, entity: MetaEntity | undefined): TaskViewKey | null {
  if (!entity || !(TASK_BEHAVIOR in (entity.behaviors ?? {}))) return null;
  const prefix = `${view.entity}.`;
  if (!view.key.startsWith(prefix)) return null;
  const key = view.key.slice(prefix.length);
  return KEYS.has(key) ? (key as TaskViewKey) : null;
}

/**
 * Подання «Сьогодні» з «Моїх задач» у `/meta` — куди веде «Усі задачі» з панелі «Сьогодні» і
 * перехід палітри. Немає (модуль вимкнено, задач людина не читає) — `null`.
 */
export function myTasksView(meta: AppMeta): MetaView | null {
  for (const view of meta.views) {
    const entity = meta.entities.find((e) => e.key === view.entity);
    if (taskViewKey(view, entity) === 'today') return view;
  }
  return null;
}
